export default "/_next/static/videos/contact-banner-horizontal.mp4";